import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Decor_feed.png'


const _withScopeId = n => (_pushScopeId("data-v-7298a259"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view status" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "status__decor",
  src: _imports_0
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "status__row"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "status__title" }, "Успешно", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "status__text" }, " Монеты бёрнграма будут зачислены на ваш баланс в ближайшее время. ", -1))
const _hoisted_6 = {
  key: 1,
  class: "status__row"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "status__title" }, "Ошибка", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "status__text" }, " Произошла ошибка при оплате, попробуйте еще раз. ", -1))

import { ref, Ref, onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentStatusView',
  setup(__props) {

const route = useRoute();

const isSuccess: Ref<boolean> = ref(false);
onBeforeMount(async () => {
	isSuccess.value = route.query.success === 'true';
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (isSuccess.value === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createVNode(_component_RouterLink, {
            to: "/",
            class: "button button-md status__button button-light"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Перейти на главную ")
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createVNode(_component_RouterLink, {
            to: "/balance",
            class: "button button-md status__button button-light"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Пополнить ")
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})